<template>
  <div>
    <b-loading :active.sync="loading" />
    <div v-if="lista_controle_irpf">
      <div class="w-full flex justify-between items-center">
        <Lynx-Title
          :text="'Planilha Controle IRPF ' + competencia_table.comp.competencia"
        />
        <Lynx-Button
          v-if="competencia_table.gerado"
          text="Atualizar planilha ou filtrar"
          class="mb-8"
          icon-size="3"
          size="small"
          @click.native="listar_controle_irpf()"
        />
        <Lynx-Button
          v-else
          text="Gerar"
          class="mb-8"
          icon-size="3"
          size="small"
          @click.native="gerar()"
        />

        <Lynx-Button
          text="Relatorio"
          class="mb-8"
          icon-size="3"
          size="small"
          @click.native="relatorio()"
        />
      </div>

      <div class="w-full flex justify-start gap-4 items-center mb-2">
        <label class="w-1/5">
          <treeselect
            :multiple="false"
            :options="lista_carteiras"
            placeholder="Selecione Carteira"
            v-model="filtros.carteira_id"
            @input="listar_controle_irpf"
          />
        </label>
        <label class="w-1/5">
          <Lynx-Input
            type="text"
            placeholder="filtre empresa"
            v-model="filtros.empresa_id"
          />
        </label>

        <label class="w-1/5">
          <treeselect
            :multiple="false"
            :options="lista_vai_fazer"
            placeholder="Selecione Vai Fazer"
            v-model="filtros.vai_fazer"
            @input="listar_controle_irpf"
          />
        </label>
           <label class="w-1/5">
          <Lynx-Input
            type="text"
            placeholder="filtre socio Id/Nome/Cpf "
            v-model="filtros.cliente"
          />
        </label>
      </div>
      <div class="w-full flex justify-start gap-4 items-center mb-2">
        <label class="w-2/5">
          <treeselect
            :multiple="false"
            :options="lista_fez"
            placeholder="Selecione Fez com a medcontabil"
            v-model="filtros.fez"
            @input="listar_controle_irpf"
          />
        </label>
        <label class="w-1/5">
          <treeselect
            :multiple="false"
            :options="lista_situacao"
            placeholder="Selecione a situação"
            v-model="filtros.situacao"
            @input="listar_controle_irpf"
          />
        </label>
        <Lynx-Button
          text="Limpar Filtros"
          icon-size="3"
          size="small"
          @click.native="limpar_filtros()"
        />
      </div>
     <div class="table-container">
      <b-table 
          backend-pagination
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :total="pagination_table.total"
          :current-page="pagination_table.current_page"
          :per-page="pagination_table.per_page"
          :columns="columns"
          :data="lista_controle_irpf"
          striped
          :sticky-header="true"
          paginated
          style="font-size: 12px"
          :style="tamanhoTela"
          :height="pagination_table.page == 10 ? '680' : '100%'"
        >
          <template slot-scope="props" v-if="props.row.id != null">
            <b-table-column style="width: 100px" field="cliente.empresas_ids">
              {{ props.row.cliente.empresas_ids }}
            </b-table-column>

            <!-- Coluna Socio -->
            <b-table-column style="width: 250px" field="cliente.nome_completo">
              {{ props.row.cliente.nome_completo }}
            </b-table-column>

            <!-- Coluna CPF -->
            <b-table-column style="width: 150px" field="cliente.cpf ">
              {{ props.row.cliente.cpf }}
            </b-table-column>
            <b-table-column
              style="width: 250px"
              field="cliente.empresa.carteirasrel.nome"
            >
              <span v-if="props.row.cliente.empresa[0]">
                {{ props.row.cliente.carteiras }}</span
              >
            </b-table-column>

            <!-- Coluna Fez com a medcontabil em -->
            <b-table-column style="width: 250px" field="fez">
              <b-select v-model="props.row.fez" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_fez"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna Vai fazer em -->
            <b-table-column style="width: 250px" field="vai_fazer">
              <b-select v-model="props.row.vai_fazer" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_vai_fazer"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna Mensagem P/ Cliente -->
            <b-table-column style="width: 250px" field="msg_cliente">
              <b-select v-model="props.row.msg_cliente" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_mensagem"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna Informações -->
            <b-table-column style="width: 250px" field="informacoes">
              <Lynx-Input
                type="text"
                placeholder="digite as informações"
                v-model="props.row.informacoes"
              />
            </b-table-column>

            <!-- Coluna Responsável -->
            <b-table-column style="width: 250px" field="usuario_id">
              <treeselect
                :multiple="false"
                :options="lista_usuarios"
                placeholder="Selecione Responsavel..."
                v-model="props.row.usuario_id"
              />
            </b-table-column>

            <!-- Coluna Situação -->
            <b-table-column style="width: 250px" field="situacao">
              <b-select v-model="props.row.situacao" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_situacao"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna Data de Envio -->
            <b-table-column style="width: 250px" field="data_envio">
              <Lynx-Input type="date" v-model="props.row.data_envio" />
            </b-table-column>

            <!-- Coluna Restituir ou a Pagar -->
            <b-table-column style="width: 250px" field="restituir">
              <b-select v-model="props.row.restituir" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_restituir"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna FIES -->
            <b-table-column style="width: 250px" field="fies">
              <b-select v-model="props.row.fies" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_fies"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna Boleto -->
            <b-table-column style="width: 250px" field="boleto">
              <b-select v-model="props.row.boleto" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_boleto"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <!-- Coluna Observações -->
            <b-table-column style="width: 250px" field="observacoes">
              <Lynx-Input
                type="text"
                placeholder="digite as observações"
                v-model="props.row.observacoes"
              />
            </b-table-column>

            <!-- Coluna Malha -->
            <b-table-column style="width: 250px" field="malha">
              <b-select v-model="props.row.malha" placeholder="Selecione">
                <option :value="null" >Selecione</option>
                <option
                  v-for="item in lista_malha"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.label }}
                </option>
              </b-select>
            </b-table-column>

            <b-table-column
              field="acoes"
              style="
                width: 200px;
                position: absolute;
                right: 35px;
                z-index: 100;
                background-color: #031127;
                color: white;
              "
            >
              <Lynx-Button
                style="color: #031127"
                class=""
                icon-size="4"
                icon="Save"
                color="white"
                @click.native="update(props.row)"
              />
            
              <Lynx-Button
                style="color: #031127"
                v-if="hasRole('super-admin') && props.row.user_up"
                icon="Paper"
                icon-size="4"

                color="white"
                @click.native="open(props.row.user_up)"
              />

              <v-snackbar
                v-if="logs"
                color="primary"
                shaped
                v-model="logs"
                :vertical="false"
              >
                <span style="font-size: 15px"
                  >ATUALIZOU: {{ user_up.nome_completo.toUpperCase() }}
                </span>
                <br />
                <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="error"
                    icon
                    v-bind="attrs"
                    @click.native="hide()"
                  >
                    <v-icon large> mdi-close </v-icon>
                  </v-btn>
                </template>
              </v-snackbar>
            </b-table-column>
          </template>
          <template v-slot:empty>
            <NotFoundData text="Nenhum convite encontrado!" />
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";

import { monthNames } from "@/utils/utils";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";

import { hasRole } from "@/utils/can";

import { mapGetters } from "vuex";
import { usersRequest } from "@/services/requests/users";

import {
  listaFezComMedcontabilNoAnoPassado,
  listaVaiFazerNoProximoAno,
  listaMensagem,
  listaSituacao,
  listaRestituirOuAPagar,
  listaFies,
  listaBoleto,
  listaMalha,
} from "./drops.js"; // Certifique-se de ajustar o caminho corretamente

export default {
  components: { NotFoundData, Treeselect },
  data() {
    return {
      lista_fez: listaFezComMedcontabilNoAnoPassado,
      lista_vai_fazer: listaVaiFazerNoProximoAno,
      lista_mensagem: listaMensagem,
      lista_situacao: listaSituacao,
      lista_restituir: listaRestituirOuAPagar,
      lista_fies: listaFies,
      lista_boleto: listaBoleto,
      lista_malha: listaMalha,
      carteira_filter: null,
      monthNames,
      modalCompetencia: false,
      selectedFiles: [],
      loading: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      logs: null,
      user_up: null,
      filtros: {
        page: 1,
        comp_controle_irpf_id: null,
        carteira_id: null,
        situacao: null,
        vai_fazer: null,
        fez: null,
        empresa_id: null,
        cliente:null
      },
      lista_usuarios: [],
      columns: [
        {
          field: "cliente.empresas_ids",
          label: "ID",
          searchable: false,
          sortable: true,
        },

        {
          field: "cliente.nome_completo",
          label: "Socio",
        },

        {
          field: "cliente.cpf",
          label: "Cpf",
        },
        {
          field: "cliente.empresa.carteirasrel.nome",
          label: "Carteira",
        },
        {
          field: "fez",
          label: "Fez com a medcontabil",
        },

        {
          field: "vai_fazer",
          label: "Vai fazer",
        },

        {
          field: "msg_cliente",
          label: "Mensagem P/ Cliente",
        },

        {
          field: "informacoes",
          label: "Informações",
        },
        {
          field: "usuario_id",
          label: "Responsavel",
        },
        {
          field: "situacao",
          label: "Situação",
        },
        {
          field: "data_envio",
          label: "Data de envio",
        },
        {
          field: "restituir",
          label: "Restituir ou a Pagar",
        },
        {
          field: "fies",
          label: "FIES",
        },
        {
          field: "boleto",
          label: "Boleto",
        },
        {
          field: "observacoes",
          label: "Observações",
        },
        {
          field: "malha",
          label: "Malha",
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
 tamanhoTela() {
      const tamanhoFixo = 3950;
      const larguraTela = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela  ) * 100;
      const tamanhoFinal = tamanhoRelativo;
      console.log(tamanhoFinal)
      return `width:${tamanhoFinal}vw;`;
    },
    lista_controle_irpf() {
      return this.$store.state.controleIrpf.lista_controle_irpf.data;
    },
    pagination_table() {
      return this.$store.state.controleIrpf.lista_controle_irpf.pagination;
    },
    competencia_table() {
      return this.$store.state.controleIrpf.lista_controle_irpf;
    },

    mensagem_alert() {
      return this.$store.state.controleIrpf.mensagem_alert;
    },
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      // data.push({ id: 'todas', label: 'todas',disabled:true });

      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      for (let i = 0; i < carteira.length; i++) {
        if (
          carteira[i].setor == "onboarding" &&
          carteira[i].nome != "Onboarding"
        ) {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      return data;
    },
  },
  mounted() {
    this.listar_controle_irpf();
    this.fetchCarteiras();
    this.getUsers();
  },
  filters: {
    formatEnToBr,
  },
  methods: {
    hasRole,
    limpar_filtros() {
      this.filtros = {
        page: 1,
        comp_controle_irpf_id: null,
        carteira_id: null,
        vai_fazer: null,
        fez: null,
        empresa_id: null,
        situacao: null,
      };
    },
    getUsers() {
      usersRequest().then(({ data: { data } }) => {
        let arrayNew = [];

        for (let i = 0; i < data.length; i++) {
          if (data[i].deleted_at == null) {
            arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
          }
        }

        this.lista_usuarios = arrayNew;
      });
    },
    onPageChange(page) {
      this.filtros.page = page;
      this.listar_controle_irpf();
    },
    open(user_up) {
      this.user_up = user_up;
      this.logs = true;
    },
    hide() {
      this.logs = false;
    },
    async gerar() {
      this.loading = true;

      await this.$store
        .dispatch("controleIrpf/create_controle_irpf", {
          comp_controle_irpf_id: this.$route.params.comp_id,
        })
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.loading = false;
        });

      this.listar_controle_irpf();
    },

    async update(controleIrpf) {
      this.loading = true;

      await this.$store
        .dispatch("controleIrpf/update_controle_irpf", controleIrpf)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async listar_controle_irpf() {
      this.loading = true;

      this.filtros.comp_controle_irpf_id = this.$route.params.comp_id;
      const {
        page,
        comp_controle_irpf_id,
        empresa_id,
        carteira_id,
        vai_fazer,
        fez,
        situacao,
        cliente,
      } = this.filtros;

      // Construa a string da rota com base nos valores dos filtros
      let rota = "controle_irpf?";

      if (page) rota += `page=${page}&`;
      if (comp_controle_irpf_id)
        rota += `comp_controle_irpf_id=${comp_controle_irpf_id}&`;
      if (carteira_id) rota += `carteira_id=${carteira_id}&`;
      if (empresa_id) rota += `empresa_id=${empresa_id}&`;
      if (vai_fazer) rota += `vai_fazer=${vai_fazer}&`;
      if (situacao) rota += `situacao=${situacao}&`;
      if (fez) rota += `fez=${fez}&`; 
      if (cliente) rota+= `cliente=${cliente}&`;

      // Remova o último '&' se existir
      rota = rota.slice(0, -1);

      await this.$store.dispatch("controleIrpf/listar_controle_irpf", rota);
      this.loading = false;
    },
    async fetchCarteiras() {
      await this.$store.dispatch("carteira/listar_carteiras");
    },

    async relatorio() {
      this.loading = true;

      this.filtros.comp_controle_irpf_id = this.$route.params.comp_id;
      const {
        page,
        comp_controle_irpf_id,
        empresa_id,
        carteira_id,
        vai_fazer,
        fez,
        situacao,
      } = this.filtros;

      // Construa a string da rota com base nos valores dos filtros
      let rota = "controle_irpf/relatorio?";

      if (comp_controle_irpf_id)
        rota += `comp_controle_irpf_id=${comp_controle_irpf_id}&`;
      if (carteira_id) rota += `carteira_id=${carteira_id}&`;
      if (empresa_id) rota += `empresa_id=${empresa_id}&`;
      if (vai_fazer) rota += `vai_fazer=${vai_fazer}&`;
      if (situacao) rota += `situacao=${situacao}&`;
      if (page) rota += `page=${page}&`;

      if (fez) rota += `fez=${fez}&`;

      // Remova o último '&' se existir
      rota = rota.slice(0, -1);

      window.open(
        `${process.env.VUE_APP_API_URL}/${rota}&token=${this.getToken}`
      );
      this.loading = false;
    },
  
  },
};
</script>

<style scoped>


</style>
  